import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { formatPrice } from 'utils';
import { ui } from 'components';
import { shopDomain } from 'api/endpoints';

const CartRow = ({
  fullProduct: {
    id,
    img,
    name,
    code,
    price,
    properties,
  },
  properties: {
    count,
    size,
    color,
  },
  addProduct,
  deleteProduct,
}) => (
  <div>
    <div className="cart-table__row">
      <div className="cart-table__row__img">
        <img src={`${shopDomain}/images/${img}.png`} alt="Фото" />
      </div>
      <div className="cart-table__row__name">
        <Link to={`/product/${id}`}>{name}</Link>
        <p>
          размер: {properties.size.find(item => item.id === size).name}
          , цвет: {properties.color.find(item => item.id === color).name}
        </p>
        <p>артикул: {code}</p>
      </div>
      <div className="cart-table__row__count">
        <ui.Buttons.QuantityButton
          count={count}
          increaseCount={() => addProduct({ id, size, color })}
          reduceCount={() => deleteProduct({ id: `${id}_${size}_${color}`, count: 1 })}
        />
      </div>
      <div className="cart-table__row__price">
        <span>{formatPrice(price)} руб.</span>
      </div>
      <div className="cart-table__row__sum">
        <span>{formatPrice(price * count)} руб.</span>
      </div>
      <div className="cart-table__row__delete">
        <ui.Buttons.DeleteButton onClick={() => deleteProduct({ id: `${id}_${size}_${color}` })} />
      </div>
    </div>
    <hr className="cart-table__hr" />
  </div>
);

CartRow.propTypes = {
  deleteProduct: PropTypes.func.isRequired,
  addProduct: PropTypes.func.isRequired,

  fullProduct: PropTypes.shape({
    id: PropTypes.string.isRequired,
    img: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    properties: PropTypes.object.isRequired,
  }).isRequired,

  properties: PropTypes.shape({
    count: PropTypes.number.isRequired,
    size: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
  }).isRequired,
};

export default CartRow;



// WEBPACK FOOTER //
// ./src/components/ui/CartTable/CartRow/index.js